import request from "@/utils/request";

export const  listItem =(data) =>{
    return request({
        url: "/businessservice/item/list",
        method:"post",
        data: data
    })
}

export const  infoItem =(query) =>{
    return request({
        url: "/businessservice/item/info",
        method:"get",
        params: query
    })
}